import React, { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row, Select, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import UsersServices from '../../../services/usersServices';
import { useSelector } from 'react-redux';
import { DrawerFormButtons } from '../../../components/common/drawersFormButtons';
import { drawerWidth, formItemLayout, notifyMessages } from '../../../utils/constants';


const AddOrderItem = ({ open, onClose, recordData, onOrderItemInsert }: { open: boolean, onClose: () => void, recordData: any, onOrderItemInsert: (values: any) => void }) => {

    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const { roles } = useSelector((state: any) => state.roles);

    const saveData = async (values: any) => {
       onOrderItemInsert(values);

        // setLoadingButton(true);
        // try {
        //     const respData = await UsersServices.updateUser(values);

        //     if (respData.success) {
        //         message.success(notifyMessages.success);
        //         getUsers();
        //         onClose();
        //     }
        //     else {
        //         message.error(notifyMessages.errorAccured);
        //     }
        // } catch (error) {
        //     message.error(notifyMessages.errorAccured);
        // }
        // finally {
        //     setLoadingButton(false);
        // }
    }

    return (
        <Drawer
            title="Add row"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"addRow"} />
            }
        >
            <Form
                id="addRow"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>                

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label="Number"
                            name="name"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label="Code"
                            name="surname"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                  
                </Row>
            </Form>
        </Drawer>
    );
}
export default AddOrderItem;